import ApplicantNavLinks from './ApplicantNavLinks';

export default ApplicantNavLinks;
